import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import HomePage from "../views/HomePage.vue";
import RegistrationView from "../views/RegistrationView.vue";
import LoginView from "../views/LoginView.vue";
import RegistrationCompleteView from "../views/RegistrationCompleteView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import EditUserDataView from "@/views/EditUserDataView.vue";
import ResetPasswordCompleteView from "@/views/ResetPasswordCompleteView.vue";
import RegistrationConfirmView from "@/views/RegistrationConfirmView.vue";
import SubscriptionHandleView from "@/views/SubscriptionHandleView.vue";
import OrderInfoView from "@/views/OrderInfoView.vue";
import { RoutePath } from "@/utils/routePath";
import RegulationsView from "@/views/RegulationsView.vue";

const routes = [
  {
    path: RoutePath.Home,
    name: "home",
    component: HomeView,
  },
  {
    path: RoutePath.HomePage,
    name: "homepage",
    component: HomePage,
  },
  {
    path: RoutePath.Login,
    name: "login",
    component: LoginView,
  },
  {
    path: RoutePath.Registration,
    name: "registration",
    component: RegistrationView,
  },
  {
    path: RoutePath.RegistrationComplete,
    name: "registrationComplete",
    component: RegistrationCompleteView,
  },
  {
    path: RoutePath.ResetPassword,
    name: "resetPassword",
    component: ResetPasswordView,
  },
  {
    path: RoutePath.ResetPasswordComplete,
    name: "resetPasswordComplete",
    component: ResetPasswordCompleteView,
  },
  {
    path: RoutePath.EditUserData,
    name: "editUserData",
    component: EditUserDataView,
  },
  {
    path: RoutePath.SubscriptionHandle,
    name: "subscriptionHandle",
    component: SubscriptionHandleView,
  },
  {
    path: RoutePath.OrderInfo,
    name: "orderInfo",
    component: OrderInfoView,
  },
  {
    path: RoutePath.RegistrationConfirm,
    name: "registrationConfirm",
    component: RegistrationConfirmView,
  },
  {
    path: RoutePath.Regulations,
    name: "regulations",
    component: RegulationsView
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: HomePage
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
